import moment from 'moment-timezone';
import type { MomentInput } from 'moment';

export const TIME_FORMAT = 'h:mm:ss A z';
export const DATE_FORMAT = 'MM/DD/YYYY';
export const DATETIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;

// Simplisafe events include a timezone number which maps to these actual zone names
const simplisafeTimezones = {
  '0': 'America/New_York',
  '1': 'America/Chicago',
  '2': 'America/Denver',
  '3': 'America/Los_Angeles',
  '4': 'America/Puerto_Rico',
  '5': 'America/Phoenix',
  '6': 'Pacific/Honolulu',
  '7': 'America/Anchorage',
}

export const getLocationDateTimeFormatted = ({
  timestamp, timezone = 0, dateFormat = DATE_FORMAT, timeFormat = TIME_FORMAT
}: {
  timestamp: MomentInput,
  timezone?: number,
  dateFormat?: string,
  timeFormat?: string,
}) => {
  const wrapper =
    typeof timestamp === 'number' ? moment.unix(timestamp) : moment.utc(timestamp);
  wrapper.tz(simplisafeTimezones[timezone.toString()]);

  return {
    date: wrapper.format(dateFormat),
    time: wrapper.format(timeFormat)
  };
};